'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EnterOutlined = _interopRequireDefault(require('./lib/icons/EnterOutlined'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var _default = _EnterOutlined;
exports.default = _default;
module.exports = _default;